import {
    Component, OnInit, OnDestroy, ViewEncapsulation, Output,
    EventEmitter, ViewChildren, QueryList, Input
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PaginationInstance } from 'ngx-pagination';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { ManuscriptList, Manuscript } from '../../../models/manuscript';
import { MssListFilters } from '../../../models/mss-list-filters';
import { ISubscription } from 'rxjs/Subscription';
import { GetMsTitlePipe } from '../../../pipes/get-ms-title.pipe';
import { OwlCarousel } from 'ngx-owl-carousel';
import { AppContentsService } from '../../../services/app-contents.service';
// import { environment } from '../../../../environments/environment';

export interface SearchSelectedImage {
    'manuscript': Manuscript;
    'image': string;
}

@Component({
  selector: 'app-search-images-list',
  templateUrl: './search-images-list.component.html',
  styleUrls: ['./search-images-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SearchImagesListComponent implements OnInit, OnDestroy {
    @Input() hideViewer: boolean;
    @ViewChildren('owlElement') owlElements: QueryList<OwlCarousel>;
    private subscriptions: Array<ISubscription> = [];
    private msImagesSubscriptions: Array<ISubscription> = [];
    private mssListFilters: MssListFilters;
    helpContent: SafeHtml;
    helpContentName: string;
    mssList: ManuscriptList = [];
    config: PaginationInstance = {
        id: 'search-images-list-nav',
        itemsPerPage: 10,
        currentPage: 1
    };
    sortBy = 'title';
    loading: Array<boolean> = [];
    pageStart = 0;
    carouselOptions = {
        autoplay: false,
        // autoWidth: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        loop: false,
        // onChanged : this.carouselEvent.bind(this),
        // onDragged : this.carouselEvent.bind(this),
        margin: 5,
        dots: false,
        nav: true,
        navElement: 'div',
        navText: [
            '<i class="fa fa-arrow-left"></i> Previous',
            ' Next <i class="fa fa-arrow-right"></i>'
        ],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            },
            1200: {
                items: 3
            }
        }
    };
    thumbs: Array<Array<String>> = [];
    @Output() selectedImage = new EventEmitter<SearchSelectedImage>();

    constructor(
        private sanitizer: DomSanitizer,
        private manuscriptsService: ManuscriptsService,
        private getMsTitlePipe: GetMsTitlePipe,
        private appContentsService: AppContentsService) {
    }

    ngOnInit(): void {
        this.mssList = [];
        this.loading = [];
        this.pageStart = 0;
        this.thumbs = [];

        /* Load help contents */
        this.subscriptions.push(
            this.appContentsService.getPageContents('search-images').subscribe(
                page => {
                    if (page && page.name === 'search-images') {
                        const helpContent = page.contents.find(c => c.name === 'help-images-list');
                        if (helpContent) {
                            this.helpContentName = helpContent.name;
                            this.helpContent = this.sanitizer.bypassSecurityTrustHtml(helpContent.text);
                        }
                    }
                },
                err => console.error(err)
            )
        );

        this.subscriptions.push(
            this.manuscriptsService.getMssListFilters().subscribe(response => this.mssListFilters = response, err => console.error(err)),
            this.manuscriptsService.getManuscripts().subscribe(
                response => {
                    if (
                        this.mssListFilters
                        && this.mssListFilters.searchImages
                        && !this.mssListFilters.searchImages.isNull()
                    ) {
                        this.mssList = response;
                        this.sortMssList('title');
                    } else {
                        this.mssList = [];
                    }
                },
                err => console.error(err)
            )
        );
    }

    sortMssList(sortBy: string) {
        this.sortBy = sortBy;
        this.mssList.sort((ms1, ms2) => {
            if (sortBy === 'date') {
                const ms1Date = ms1.__date.ah.from ? ms1.__date.ah.from : 9999;
                const ms2Date = ms2.__date.ah.from ? ms2.__date.ah.from : 9999;
                return ms1Date - ms2Date;
            } else {
                const ms1Title = this.getMsTitlePipe.transform(ms1, 'short');
                const ms2Title = this.getMsTitlePipe.transform(ms2, 'short');
                if (ms1Title > ms2Title) {
                    return 1;
                }
                if (ms1Title < ms2Title) {
                    return -1;
                }
                return 0;
            }
        });

        /* Refresh thumbs after mss sorting */
        this.loadThumbs(true);

        /* Go to first navigation page */
        this.changePage(1);
    }

    private resetThumbs() {
        for (const subscription of this.msImagesSubscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
        this.msImagesSubscriptions = [];
        this.thumbs = [];
    }

    loadThumbs(reset: boolean = false) {
        if (reset) {
            this.resetThumbs();
        }
        if (this.mssList && this.mssList.length > 0) {
            this.pageStart = (this.config.currentPage - 1) * this.config.itemsPerPage;
            let pageEnd = this.pageStart + this.config.itemsPerPage;
            if (pageEnd > this.mssList.length) {
                pageEnd = this.mssList.length;
            }

            for (let i = this.pageStart; i < pageEnd; i++) {
                this.loading[i] = true;
                const msRow = this.mssList[i];

                if (!this.msImagesSubscriptions[msRow.pkid]) {
                    this.msImagesSubscriptions[msRow.pkid] = this.manuscriptsService.searchManuscriptImageLinks(
                        msRow.pkid,
                        this.mssListFilters.searchImages
                    ).subscribe(
                        response => {
                            if (response) {
                                this.thumbs[i] = response.map(imageLink => imageLink.image);
                                this.loading[i] = false;
                            }
                        },
                        err => console.error(err)
                    );
                }
            }
        }
    }

    changePage(pageNum: number) {
        this.config.currentPage = pageNum;
        this.loadThumbs();
    }

//    carouselEvent(event: any): void {
//        if (
//            event.item.index  // position of the current item
//            && event.item.count // number of items
//            && event.item.index >= (event.item.count - event.page.size)
//        ) {
//            // this.carouselAddImages(this.loadNextImages());
//        }
//    }

    updateViewer(manuscript: Manuscript, image: string): void {
        /* Forces to refresh carousels before activating the viewer display */
        if (this.hideViewer) {
            this.owlElements.forEach(owlElement => {
                owlElement.trigger('add.owl.carousel', ['']);
                owlElement.trigger('refresh.owl.carousel');
            });
        }
        /* Emit update event */
        this.selectedImage.emit({manuscript: manuscript, image: image});
    }

    ngOnDestroy() {
        this.manuscriptsService.resetFilters();

        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
        for (const subscription of this.msImagesSubscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/search-images-list/search-images-list.component.ts